import { render, staticRenderFns } from "./editFranchise.vue?vue&type=template&id=ce6f3c64&"
import script from "./editFranchise.vue?vue&type=script&lang=js&"
export * from "./editFranchise.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports